import React from 'react';
import PageWrapper from '@/components/ui/PageWrapper';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '@/common/SafeIcon';

const Contact = () => {
  return (
    <PageWrapper>
      <div className="py-24 bg-bgDark min-h-screen">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-10">
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-5xl font-heading font-bold mb-4">Get in Touch</h1>
            <p className="text-textMuted max-w-2xl mx-auto">Whether you're looking for a quote, have a question about our services, or want to drop by the studio, we'd love to hear from you.</p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            {/* Contact Info */}
            <motion.div initial={{ opacity: 0, x: -30 }} animate={{ opacity: 1, x: 0 }} className="space-y-10">
              <div>
                <h3 className="text-2xl font-heading font-bold mb-6 text-accent">Studio Information</h3>
                <div className="space-y-6">
                  <div className="flex items-start gap-4">
                    <div className="bg-primary p-3 rounded-lg border border-white/5">
                      <SafeIcon icon={FiIcons.FiMapPin} className="text-accent text-xl" />
                    </div>
                    <div>
                      <h4 className="font-bold mb-1">Address</h4>
                      <p className="text-textMuted">7350 Boulevard Henri-Bourassa Ouest<br/>Montreal, QC H4S 1P9</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start gap-4">
                    <div className="bg-primary p-3 rounded-lg border border-white/5">
                      <SafeIcon icon={FiIcons.FiPhone} className="text-accent text-xl" />
                    </div>
                    <div>
                      <h4 className="font-bold mb-1">Phone</h4>
                      <p className="text-textMuted">(514) 555-0157</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="bg-primary p-3 rounded-lg border border-white/5">
                      <SafeIcon icon={FiIcons.FiMail} className="text-accent text-xl" />
                    </div>
                    <div>
                      <h4 className="font-bold mb-1">Email</h4>
                      <p className="text-textMuted">hello@obsidianautospa.ca</p>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <h3 className="text-2xl font-heading font-bold mb-6 text-accent">Operating Hours</h3>
                <ul className="space-y-3 bg-primary p-6 rounded-xl border border-white/5">
                  <li className="flex justify-between border-b border-white/5 pb-2">
                    <span className="text-textMuted">Monday - Friday</span>
                    <span className="font-medium">8:00 AM - 7:00 PM</span>
                  </li>
                  <li className="flex justify-between border-b border-white/5 pb-2">
                    <span className="text-textMuted">Saturday</span>
                    <span className="font-medium">9:00 AM - 5:00 PM</span>
                  </li>
                  <li className="flex justify-between">
                    <span className="text-textMuted">Sunday</span>
                    <span className="font-medium text-accent">Closed</span>
                  </li>
                </ul>
              </div>
            </motion.div>

            {/* Contact Form */}
            <motion.div initial={{ opacity: 0, x: 30 }} animate={{ opacity: 1, x: 0 }}>
              <div className="bg-primary p-8 rounded-2xl border border-white/5 shadow-2xl">
                <h3 className="text-2xl font-heading font-bold mb-6">Send a Message</h3>
                <form className="space-y-5" onSubmit={(e) => { e.preventDefault(); alert('Message sent! (Demo)'); }}>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                    <div>
                      <label className="block text-sm font-medium text-textMuted mb-2">First Name</label>
                      <input type="text" className="input-field" required />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-textMuted mb-2">Last Name</label>
                      <input type="text" className="input-field" required />
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-textMuted mb-2">Email</label>
                    <input type="email" className="input-field" required />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-textMuted mb-2">Subject</label>
                    <input type="text" className="input-field" required />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-textMuted mb-2">Message</label>
                    <textarea className="input-field h-32 resize-none" required></textarea>
                  </div>
                  <button type="submit" className="btn-primary w-full py-4">Send Message</button>
                </form>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default Contact;